import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { Modal } from 'antd'

import { usePet, notifOps } from '../../modules'

const Settings = ({ toggle, visible }) => {
    const [station, setStation] = useState(localStorage.getItem('origin'))
    const [groups, setGroups] = useState([])
    const { enqueueSnackbar } = useSnackbar()

    const modify = e => {
        let tmp = [...groups]
        tmp[e.target.name].ip = e.target.value

        setGroups(tmp)
    }

    usePet('itemGroups', null, { notify: true, callback: async ({ data }) => { 
        data = data.map(group => {
            group.ip = localStorage.getItem(group.name)
            return group
        })
        setGroups(data) 
    } })

    const onSave = () => {
        let filled = groups.filter(group => group.ip?.length > 0)
        filled.forEach(group => localStorage.setItem(group.name, group.ip))
        localStorage.setItem('origin', station)
        enqueueSnackbar('Settings have been saved', notifOps('success'))
        setTimeout(toggle, 300)
    }

    return (
        <Modal 
            title="Settings" 
            width={ 500 }
            visible={visible} 
            footer={ null }
            onCancel={ toggle }>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="grid-name">
                        Station Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-black border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-station"
                        value={ station }
                        onChange={ e => setStation(e.target.value) }
                        type="text"
                        placeholder="Restaurant" />
                </div>
            </div>
            {
                groups.map((group, i) =>
                    <div className="flex flex-wrap mt-3">
                        <div className="w-full px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="grid-name">
                                { group.name }
                            </label>
                            <input
                                className="appearance-none block w-full bg-gray-200 text-black border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id={ `grid-${ group.name }` }
                                name={ i }
                                value={ group.ip }
                                onChange={ modify }
                                type="text"
                                placeholder="192.168.0.102" />
                        </div>
                    </div>
                )
            }
            <div className="flex justify-end">
                <button onClick={ onSave } className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
            </div>
        </Modal>
    )
}

export default Settings